// extracted by mini-css-extract-plugin
export default {"operation-panel-message":"index_operation-panel-message__2YNWB"};